var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "match",
    clipPath: "url(#clip0_311_335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "match_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ligne 19",
    d: "M2.8418 2.35083H7.53957",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 315",
    d: "M3.56836 9.15251V2.53265M6.81266 2.53265V6.38849",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 316",
    d: "M1.24617 27.6111H26.7534M25.6188 27.3341V14.4035H27.6109V11.9729L13.9998 0.388916L0.388672 11.9671V14.3977H2.38076V27.3282",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 317",
    d: "M13.9998 25.6035C13.9846 25.0098 14.0884 24.419 14.3052 23.866C14.5219 23.313 14.8471 22.8089 15.2617 22.3836C15.6763 21.9583 16.1718 21.6203 16.7191 21.3895C17.2663 21.1586 17.8543 21.0397 18.4482 21.0397C19.0422 21.0397 19.6301 21.1586 20.1774 21.3895C20.7247 21.6203 21.2202 21.9583 21.6348 22.3836C22.0494 22.8089 22.3746 23.313 22.5913 23.866C22.808 24.419 22.9118 25.0098 22.8966 25.6035V27.3399M5.10497 27.3399V25.6035C5.08977 25.0098 5.19359 24.419 5.41031 23.866C5.62702 23.313 5.95226 22.8089 6.36683 22.3836C6.78141 21.9583 7.27694 21.6203 7.82421 21.3895C8.37148 21.1586 8.95943 21.0397 9.55338 21.0397C10.1473 21.0397 10.7353 21.1586 11.2825 21.3895C11.8298 21.6203 12.3254 21.9583 12.7399 22.3836C13.1545 22.8089 13.4797 23.313 13.6965 23.866C13.9132 24.419 14.017 25.0098 14.0018 25.6035V27.335",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 116",
    d: "M11.1923 20.2407C12.1555 19.2774 12.1555 17.7157 11.1923 16.7525C10.229 15.7892 8.6673 15.7892 7.70406 16.7525C6.74082 17.7157 6.74082 19.2774 7.70406 20.2407C8.6673 21.2039 10.229 21.2039 11.1923 20.2407Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 117",
    d: "M20.6493 19.7907C21.3654 18.6319 21.0065 17.1119 19.8477 16.3959C18.6889 15.6798 17.1689 16.0387 16.4529 17.1975C15.7368 18.3563 16.0957 19.8762 17.2545 20.5923C18.4133 21.3084 19.9332 20.9495 20.6493 19.7907Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 118",
    d: "M14.1601 14.001C16.2776 13.9129 17.9227 12.1248 17.8345 10.0074C17.7464 7.88987 15.9584 6.24478 13.8409 6.33293C11.7234 6.42109 10.0783 8.20911 10.1665 10.3266C10.2546 12.4441 12.0426 14.0892 14.1601 14.001Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 318",
    d: "M15.0957 9.08252L13.6374 11.2749L12.9033 10.1792",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomies);
export default __webpack_public_path__ + "static/media/roomies.4d52ec998ab7dfb6821e4d961cb5862f.svg";
export { ForwardRef as ReactComponent };